import { HttpInterceptorFn } from '@angular/common/http';
import { from } from 'rxjs';
import { switchMap } from 'rxjs/operators';

import { keycloak } from './keycloak';
import { config } from '../config';

function normalizeBaseUrl(url: string): string {
  return (url || '').replace(/\/+$/, '');
}

function isTargetApiUrl(requestUrl: string): boolean {
  const url = requestUrl || '';

  // اگر نسبی بود
  if (url.startsWith('/')) {
    // اینجا فقط مسیرهای backend خودت رو پوشش میدیم
    return url.startsWith('/api');
  }

  const baseApi = normalizeBaseUrl(config.apiUrl);
  const baseAuth = normalizeBaseUrl(config.apiAuthUrl);

  const normalizedReq = url.replace(/\/+$/, '');

  const matchApi = baseApi.length > 0 && normalizedReq.startsWith(baseApi);
  const matchAuth = baseAuth.length > 0 && normalizedReq.startsWith(baseAuth);

  return matchApi || matchAuth;
}

export const keycloakInterceptor: HttpInterceptorFn = (req, next) => {
  // فقط درخواست‌های بک‌اند خودت
  if (!isTargetApiUrl(req.url)) {
    return next(req);
  }

  // refresh token قبل از هر request
  return from(keycloak.updateToken(30)).pipe(
    switchMap(() => {
      const token = keycloak.token;

      if (!token) {
        return next(req);
      }

      return next(
        req.clone({
          setHeaders: { Authorization: `Bearer ${token}` },
        }),
      );
    }),
  );
};